export default __webpack_public_path__ + "static/media/006-roundabout.69596cc1.png";